import { Box, Button, CircularProgress, Dialog, Grid, TextField, Typography } from "@mui/material";
import { useState, type Dispatch, type SetStateAction } from "react";

import { handleContactFormChange, handleContactFormSubmit } from "../utils/helpers/formHelpers";
import type { IContactForm, IContactToast } from "../utils/helpers/formHelpers";

import { Send } from "@mui/icons-material";

interface IMissingValuesDialogProps {
    openMissingModal: boolean;
    setOpenMissingModal: (b: boolean) => void;
    setToast: Dispatch<SetStateAction<IContactToast>>;
}

const MissingValuesDialog: React.FC<IMissingValuesDialogProps> = ({ openMissingModal, setOpenMissingModal, setToast }) => {
    const [form, setForm] = useState<IContactForm>({
        type: "addition",
        subject: "",
        message: "",
    });
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        handleContactFormSubmit(e, form, setToast, setForm, setSubmitting, setErrors).finally(() => setOpenMissingModal(false));
    };

    return (
        <Dialog open={openMissingModal} onClose={() => setOpenMissingModal(false)}>
            <Box>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ p: { xs: 4, md: 5 } }}>
                    <Typography sx={{ mb: 2 }} variant="h6">
                        Are we missing an ingredients option? Let us know!
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <TextField
                                label={"Ingredient Name"}
                                value={form.subject}
                                onChange={handleContactFormChange("subject", setForm)}
                                error={Boolean(errors.subject)}
                                helperText={errors.subject}
                                fullWidth
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                label={"Description"}
                                value={form.message}
                                onChange={handleContactFormChange("message", setForm)}
                                error={Boolean(errors.message)}
                                helperText={errors.message}
                                placeholder="Tell us about this ingredient!"
                                fullWidth
                                multiline
                                minRows={8}
                                maxRows={8}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    startIcon={submitting ? <CircularProgress size={20} /> : <Send />}
                                    disabled={submitting}
                                    sx={{ borderRadius: 999, px: 3, width: "100%", color: "white" }}
                                >
                                    {submitting ? "Sending…" : "Send message"}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Dialog>
    );
};

export default MissingValuesDialog;
